





































































































































import SelectYearMounth from "@/shared/components/select-year-mounth.vue";
import dayjs from "dayjs";
import { Component, Mixins, Watch } from "vue-property-decorator";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { HomeService, Usuario } from "@/services/home.service";
import WidgetNivelVendedor from "./widgets/WidgetNivelVendedor.vue";
import WidgetRankingVendedores from "./widgets/WidgetRankingVendedores.vue";
import WidgetMetaAtualVendedor from "./widgets/WidgetMetaAtualVendedor.vue";
import WidgetResumoVendasVendedor from "./widgets/WidgetResumoVendasVendedor.vue";
import WidgetUltimasVendasVendedor from "./widgets/WidgetUltimasVendasVendedor.vue";
import {
  DashboardVendedorDados,
  DashboardVendedorService,
} from "@/services/dashboard-vendedor.service";

@Component({
  components: {
    SelectYearMounth,
    WidgetNivelVendedor,
    WidgetResumoVendasVendedor,
    WidgetUltimasVendasVendedor,
    WidgetRankingVendedores,
    WidgetMetaAtualVendedor,
  },
})
export default class Vendedor extends Mixins(GlobalMixin) {
  loading = true;
  usuarioAtual: Usuario | null = null;
  mesAno: string = dayjs().format("YYYY-MM");
  idVendedorSelecionado = 0;

  get idUsuarioAtual(): number {
    return Number(this.usuarioAtual?.idUsuario || 0);
  }

  get isAdmin(): boolean {
    return !!this.usuarioAtual?.administrador;
  }

  get fechado(): boolean {
    return !!this.dados?.dataFechamento;
  }

  get hasMetaAtual(): boolean {
    return !!this.dados?.metaAtual;
  }

  get primeiroNome(): string {
    const nomeSelecionado =
      this.dados?.ranking.find(
        (item) => item.idUsuario === this.idVendedorSelecionado,
      )?.nome || "";

    const nome =
      nomeSelecionado.trim() || this.usuarioAtual?.nome?.trim() || "";

    if (!nome) {
      return "";
    }

    return nome.split(" ")[0];
  }

  dados: DashboardVendedorDados | null = null;

  get mesAnoLabel(): string {
    return dayjs(`${this.mesAno}-01`).format("MMMM YYYY");
  }

  async mounted() {
    this.usuarioAtual = await HomeService.Logado();
    this.idVendedorSelecionado = this.idUsuarioAtual;
    await this.carregarDashboard();
  }

  @Watch("mesAno")
  async onChangeMesAno() {
    await this.carregarDashboard();
  }

  async carregarDashboard() {
    if (!this.idVendedorSelecionado) {
      return;
    }

    this.loading = true;

    this.dados = await DashboardVendedorService.ObterDashboard({
      idVendedor: this.idVendedorSelecionado,
      mesAno: this.mesAno,
    }).finally(() => (this.loading = false));
  }

  async onSelecionarVendedor(idVendedor: number) {
    if (!this.isAdmin || idVendedor === this.idVendedorSelecionado) {
      return;
    }

    this.idVendedorSelecionado = idVendedor;
    await this.carregarDashboard();
  }
}
